<script setup>
import { useI18n } from 'vue-i18n';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';

defineProps({
  signer: { type: Object, required: true },
  eventLabel: { type: String, default: '' },
  statusLabel: { type: String, required: true },
  signed: { type: Boolean, default: false },
  canResend: { type: Boolean, default: false },
  isResending: { type: Boolean, default: false },
});

const emit = defineEmits(['resend']);
const { t } = useI18n();
</script>

<template>
  <li
    class="flex gap-3 text-sm"
    :class="signed ? 'text-lais-text' : 'text-lais-text-muted'"
  >
    <span
      v-if="signed"
      class="i-lucide-circle-check size-6 shrink-0 text-lais-success"
    />
    <span
      v-else
      class="mt-1 size-3 shrink-0 animate-pulse rounded-full bg-lais-warning"
    />
    <div class="flex min-w-0 flex-1 flex-wrap items-center gap-x-3 gap-y-1">
      <span class="min-w-0">
        <strong>{{ eventLabel }}</strong>
        <span class="ms-1">{{ statusLabel }}</span>
      </span>
      <LaisPrimaryButton
        v-if="canResend"
        size="sm"
        variant="link"
        icon="i-lucide-send"
        class="btn-reenviar"
        :is-loading="isResending"
        :disabled="isResending"
        @click="emit('resend', signer)"
      >
        {{ t('SALES.DETAIL.RECEIPT.RESEND') }}
      </LaisPrimaryButton>
    </div>
  </li>
</template>
